// -- Regular constants ------------------------------------------------------------------------------------------------
export const PARA__SHIPPING_INCL        = 'shipping_incl';
export const PARA__TEST_MODE            = 'test';
export const PARA__VAT_INCL             = 'vat_incl';
